import { render, staticRenderFns } from "./TheMenuSubitem.vue?vue&type=template&id=f2215688&"
import script from "./TheMenuSubitem.vue?vue&type=script&lang=js&"
export * from "./TheMenuSubitem.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuSubitem.vue?vue&type=style&index=0&id=f2215688&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports